import { ActionButton } from './ActionButtons.style';

export type UserAction = {
  fireAction: () => void;
  label: string;
  style?: React.CSSProperties;
};
type IActionButtonsProps = {
  actions: UserAction[];
};

const ActionButtons = (props: IActionButtonsProps) => {
  const { actions } = props;
  return (
    <>
      {actions.map(action => (
        <ActionButton
          type="button"
          tx={action.label}
          margin="2rem"
          key={action.label}
          onClick={action.fireAction}
        />
      ))}
    </>
  );
};

export default ActionButtons;
